"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfShiftSearchResultItemDto = instanceOfPaginatedResponseOfShiftSearchResultItemDto;
exports.PaginatedResponseOfShiftSearchResultItemDtoFromJSON = PaginatedResponseOfShiftSearchResultItemDtoFromJSON;
exports.PaginatedResponseOfShiftSearchResultItemDtoFromJSONTyped = PaginatedResponseOfShiftSearchResultItemDtoFromJSONTyped;
exports.PaginatedResponseOfShiftSearchResultItemDtoToJSON = PaginatedResponseOfShiftSearchResultItemDtoToJSON;
exports.PaginatedResponseOfShiftSearchResultItemDtoToJSONTyped = PaginatedResponseOfShiftSearchResultItemDtoToJSONTyped;
const ShiftSearchResultItemDto_1 = require("./ShiftSearchResultItemDto");
const PaginationMetaDto_1 = require("./PaginationMetaDto");
/**
 * Check if a given object implements the PaginatedResponseOfShiftSearchResultItemDto interface.
 */
function instanceOfPaginatedResponseOfShiftSearchResultItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfShiftSearchResultItemDtoFromJSON(json) {
    return PaginatedResponseOfShiftSearchResultItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfShiftSearchResultItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(ShiftSearchResultItemDto_1.ShiftSearchResultItemDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfShiftSearchResultItemDtoToJSON(json) {
    return PaginatedResponseOfShiftSearchResultItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfShiftSearchResultItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(ShiftSearchResultItemDto_1.ShiftSearchResultItemDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfShiftSearchResultItemDto.js.map